/**
 * Group Joined Trigger Component
 *
 * Trigger: "been added to this group"
 * Shows: group select
 */

import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { fetchAllGroups } from 'src/models/group/group';
import { FormSelect } from 'src/shared/Forms/Fields/FormSelect';

import { TriggerComponentProps } from '../automationTriggers';

export const GroupJoinedTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();
  const { data: groups = [] } = useQuery({
    queryKey: ['groups'],
    queryFn: () => fetchAllGroups(),
    staleTime: 60000,
  });

  const groupOptions = groups.map((group) => ({
    value: String(group.id),
    label: group.name,
  }));

  const selectedGroup = groups.find(
    (g) => String(g.id) === String(automation.reminderTypeId)
  );

  if (readOnly) {
    if (selectedGroup?.name) {
      return <span>{t('automations.triggers.addedToGroupNamed', { name: selectedGroup.name })}</span>;
    }
    return <span>{t('automations.triggers.addedToGroup')}</span>;
  }

  // Edit mode
  return (
    <Box sx={{ maxWidth: 300 }}>
      <FormSelect
        name={`automations.${index}.reminderTypeId`}
        label={t('automations.triggerLabels.group')}
        options={groupOptions}
        prompt={t('automations.triggerLabels.selectGroup')}
      />
    </Box>
  );
};
